import React from "react";
import { useHeaderHeight } from "../../../hooks/useHeaderHeight";
import { useIsTouchDevice } from "../../../hooks/useIsTouchDevice";
import { useScrollHeight } from "../../../hooks/useScrollHeight";
import useWindowWidth from "../../../hooks/useWindowWidth";
import { isSpecificSite } from "../../../utils/isSpecificSite";
import HeaderDesktop from "./Desktop/HeaderDesktop";
import HeaderMobile from "./Mobile/HeaderMobile";
import HeaderTablet from "./Tablet/HeaderTablet";

interface HeaderProps {
	breadcrumbs?: DogsTrust.Breadcrumb[];
	nestedLinks?: DogsTrust.MenuItem[];
	promoCards?: DogsTrust.PromotionCardToDisplayProps[];
}
/**
 * Main navigation accessibility reference https://www.w3.org/WAI/ARIA/apg/patterns/menubar/examples/menubar-navigation/
 *
 *   ///TODO AAA level accessibility improvements:
 *
 * - If we have a sub menu button to open another menu, enable the right arrow key to open this as well as our existing enter key
 * - Enable up & down key functionality so users can navigate through the sub menu items without having to use tab
 * - Enable left & right arrow keys for navigating between top menu items (e.g. Rehoming, Dog Advice, etc.)
 * - Enable up & down arrow keys for opening the menu from the top level items (e.g. Rehoming, Dog Advice, etc.)
 * - Enable Home & End keys to navigate between first and last menu items (through each tier)
 * - Enable users to type characters and focus is directed towards the link that matches (through each tier)
 */

export const Header: React.FC<HeaderProps> = ({
	breadcrumbs = [],
	nestedLinks = [],
	promoCards = [],
}) => {
	isSpecificSite("ie", "Header");

	const headerHeight = useHeaderHeight();
	const scrollHeight = useScrollHeight();
	const touchDevice = useIsTouchDevice();
	const windowWidth = useWindowWidth();

	if (windowWidth >= 1024 && !touchDevice)
		return (
			<HeaderDesktop
				nestedLinks={nestedLinks}
				scrollHeight={scrollHeight}
				headerHeight={headerHeight}
				breadcrumbs={breadcrumbs}
				promoCards={promoCards.slice(0, 2)}
			/>
		);
	if (windowWidth >= 601)
		return (
			<HeaderTablet
				nestedLinks={nestedLinks}
				scrollHeight={scrollHeight}
				headerHeight={headerHeight}
				breadcrumbs={breadcrumbs}
				promoCards={promoCards}
			/>
		);
	return (
		<HeaderMobile
			nestedLinks={nestedLinks}
			scrollHeight={scrollHeight}
			headerHeight={headerHeight}
			breadcrumbs={breadcrumbs}
		/>
	);
};

export default Header;
